import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { ROUTES } from '../constants/routes';

interface Props {
  permission: string;
}

/**
 * Route-level permission guard. Renders child routes only if the current user
 * has the given permission (checked via effectivePermissions from the backend,
 * with ic-admin / super-admin bypass). On denial, redirects to /dashboard.
 */
export default function PermissionRouteGuard({ permission }: Props) {
  const { can } = useAuth();

  if (!can(permission)) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <Outlet />;
}
